(function() {
  'use strict';

  let hasMovedMobilePicker = false;
  let resizeTimer;

  function moveCurrencyToHeader() {
    if (window.innerWidth <= 990) {
      return;
    }

    const currencyPicker = document.querySelector('.pick_currency.mldesk');
    const headerContainer = document.getElementById('mlv-header-container');

    if (currencyPicker && headerContainer && !headerContainer.contains(currencyPicker)) {
      headerContainer.appendChild(currencyPicker);

      currencyPicker.style.cssText = `
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: static !important;
        transform: none !important;
        margin: 0 !important;
        margin-right: 3px !important;
        padding-top: 3px !important;
      `;

      currencyPicker.classList.remove('DRAWER');

      reinitNiceSelect(currencyPicker, 'desktop');
    }
  }

  function reinitNiceSelect(pickerElement, mode) {
    setTimeout(() => {
      if (typeof jQuery !== 'undefined' && jQuery.fn.niceSelect) {
        const $select = jQuery(pickerElement).find('select');
        try {
          $select.niceSelect('destroy');
          $select.niceSelect();
          
          if (mode === 'mobile') {
             fixMobileDropdownPosition(pickerElement);
          }
          console.log(`✓ Currency selector ${mode} initialized`);
        } catch(e) {
          console.log('Nice-select init warning:', e);
        }
      }
    }, 200);
  }

  // === GLOBAL CSS INJECTION UNTUK DROP-DOWN ===
  function fixMobileDropdownPosition() {
    if (!document.getElementById('mlv-dropdown-fix')) {
      const style = document.createElement('style');
      style.id = 'mlv-dropdown-fix';
      style.innerHTML = `
        #mlv-mobile-slot .nice-select .list {
          top: 100% !important;
          bottom: auto !important;
          margin-top: 8px !important;
          max-height: 200px !important;
          overflow-y: auto !important;
          left: 0 !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // === SYNC: Sinkronisasi perubahan nilai Desktop <-> Mobile ===
  function syncCurrencyChange(selectElement) {
    selectElement.addEventListener('change', function() {
      const selectedValue = this.value;
      
      const allSelects = document.querySelectorAll('.pick_currency select');
      allSelects.forEach(select => {
        if (select !== selectElement) {
          select.value = selectedValue;
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
          
          if (typeof jQuery !== 'undefined' && jQuery.fn.niceSelect) {
            jQuery(select).niceSelect('update');
          }
        }
      });

      const mlvForm = document.querySelector('form[action*="currency"]');
      if (mlvForm) mlvForm.submit();
    });
  }

  // === MOBILE: Pindahkan ke slot header mobile ===
  function movePickerToMobileSlot() {
    if (window.innerWidth > 990) return; 

    const mobileSlot = document.getElementById('mlv-mobile-slot');
    const originalPicker = document.querySelector('.pick_currency.mldesk');

    if (!mobileSlot || !originalPicker) return;
    
    if (mobileSlot.contains(originalPicker)) return;

    mobileSlot.appendChild(originalPicker);
    originalPicker.classList.add('DRAWER');

    originalPicker.style.cssText = `
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
      position: static !important;
      width: fit-content !important;
      margin: 0 !important;
      padding: 0 !important;
      transform: scale(0.75) !important;
      transform-origin: left center !important;
    `;

    reinitNiceSelect(originalPicker, 'mobile');
    fixMobileDropdownPosition();
    hasMovedMobilePicker = true;
  }

  function init() {
    moveCurrencyToHeader();
    movePickerToMobileSlot();
    setTimeout(() => {
      const desktopSelect = document.querySelector('.pick_currency.mldesk select');
      if (desktopSelect) syncCurrencyChange(desktopSelect);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) shouldCheck = true;
    });
    if (shouldCheck) {
      moveCurrencyToHeader();
      movePickerToMobileSlot();
    }
  });

  setTimeout(() => {
    observer.observe(document.body, { childList: true, subtree: true });
    moveCurrencyToHeader(); // Force check
    movePickerToMobileSlot();
  }, 500);

  // RESIZE EVENT 
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      
      if (window.innerWidth > 990) {
        
        const picker = document.querySelector('.pick_currency.DRAWER') || document.querySelector('.pick_currency.mldesk');
        const headerContainer = document.getElementById('mlv-header-container');

        if (picker && headerContainer) {
          headerContainer.appendChild(picker); 
          picker.classList.remove('DRAWER'); 
          
          reinitNiceSelect(picker, 'desktop');
        }

        const mobileSlot = document.getElementById('mlv-mobile-slot');
        if (mobileSlot) mobileSlot.innerHTML = '';

        hasMovedMobilePicker = false;
        
        moveCurrencyToHeader();
      }
      else {
        const headerContainer = document.getElementById('mlv-header-container');
        const desktopPicker = headerContainer ? headerContainer.querySelector('.pick_currency.mldesk:not(.DRAWER)') : null;
        
        movePickerToMobileSlot();
      }
    }, 250);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      hasMovedMobilePicker = false;
      init();
    });
  }

})();